
const urls = {
   get BASE_URL() {
      const href = window.location.href;
      if (href.includes("salaryuncle.salarytopup.com")) return 'https://salaryuncle.salarytopup.in';
      if (href.includes("https://salaryuncle.com")) return 'https://crm.salaryuncle.com';
      if (href.includes("https://www.salaryuncle.com")) return 'https://crm.salaryuncle.com';
      return 'https://crm.salaryuncle.com/*  */';
   },
   // Blog/news images are uploaded to S3 with a *private* ACL (CRM
   // file_handling_with_s3.php), so linking the bucket directly returns 403 in
   // the browser. The CRM's public DocsController::directViewDocument route
   // reads the object server-side and streams it back. The API returns a bare
   // filename and the frontend prepends this base.
   get BASE_IMAGE_URL() {
      return `${this.BASE_URL}/direct-document-file/`;
   },
   get API_BASEPATH() {
      return `${this.BASE_URL}/api`;
   },
   // Public-facing website domain (canonical links, payment redirects)
   get SITE_URL() {
      const href = window.location.href;
      if (href.includes("www.salaryuncle.com")) return 'https://www.salaryuncle.com';
      if (href.includes("salaryuncle.com")) return 'https://salaryuncle.com';
      if (href.includes("salaryuncle.salarytopup.com")) return 'https://salaryuncle.salarytopup.com';
      return 'http://localhost:3000';
   },
   payment:{
       SEND_OTP: "/Api/CustomerDetails/Sendotp",
       VERIFY_OTP: "/Api/CustomerDetails/verifyOtp",
       PAYU_ORDERS: "/Api/RepayLoanApi/payuOrders",
       INITIALIZE_PAYMENT: "/post_payment/initialize",
       INITIALIZE_PAYTM: "/post_payment/initialize_paytm",
       SEND_CUSTOMER_QUERY: "/SendCustomerQuery",
   },
    loan:{
       SEND_OTP: "/Api/Website/InstantJourneyController/appCustomerRegisteration",
       VERIFY_OTP: "/Api/Website/InstantJourneyController/appCustomerRegisteration",
       GET_DASHBOARD: "/Api/Website/InstantJourneyController/getDashboardData",
       VERIFY_PAN: "/Api/Website/InstantJourneyController/appCustomerRegisteration",
       PERSONAL_DETAILS: "/Api/Website/InstantJourneyController/appCustomerRegisteration",
       INCOME_DETAILS: "/Api/Website/InstantJourneyController/appCustomerRegisteration",
       ADDRESS_DETAILS: "/Api/Website/InstantJourneyController/appCustomerRegisteration",
       CUSTOMER_DOCUMENT: "/Api/Website/InstantJourneyController/saveleadDetails",
       STATE_CITY_PINCODE:"/Api/MasterController/masterAPI",
       UPLOAD_PROFILE_PIC:"/Api/Website/InstantJourneyController/appCustomerRegisteration",
       PROFILE_PIC:"/Api/Website/InstantJourneyController/appCustomerRegisteration",
       CHECK_ELIGIBILITY:"/Api/Website/InstantJourneyController/appCustomerRegisteration",
       ABOUT_COMPANY:"/Api/Website/InstantJourneyController/saveleadDetails",
       CALCULATE_LOAN:"/Api/Website/InstantJourneyController/saveleadDetails",
       USER_DATA:"/Api/Website/getUser",
       ALL_LEADS: "/Api/Website/InstantJourneyController/getLeadList",
       LOAN_DETAIL: "/Api/Website/InstantJourneyController/getLeadDetail",
       GENERATE_LOAN:"/Api/Website/InstantJourneyController/saveleadDetails",
       GENERATE_ORDER_ID:"/Api/Website/InstantJourneyController/generateRazorpayorderId",
       MANDATORY_DOCS:"/Api/Website/InstantJourneyController/check_customer_mandatory_documents",
       ALL_BLOGS:"/Api/Website/BlogsController/blog",
       BLOG_DETAILS:"/Api/Website/BlogsController/blogDetail"
    }
}

export default urls;